import {takeLatest, put, call} from 'redux-saga/effects';
import {GET_NEWS_DETAIL_POST_ERROR, GET_NEWS_DETAIL_POST_START, GET_NEWS_DETAIL_POST_SUCCESS} from "../../types";

import apiCall from '../../api/apiGet';

export function* get({payload}) {
  try {
    const url = `/posts/`;
    const method = 'GET';
    const headers = {Authorization: 'Bearer ' + payload.token};
    const results = yield call(apiCall, url, method, headers);
    yield put({type: GET_NEWS_DETAIL_POST_SUCCESS, results: results.data});
  } catch (error) {
    yield put({type: GET_NEWS_DETAIL_POST_ERROR, error});
  }
}

export default function* posts_detail() {
  yield takeLatest(GET_NEWS_DETAIL_POST_START, get);
}